/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_Hint_Upper_LowerInputs */

const en_us2_profile_editors_split_hint_upper_lower = /** @type {(inputs: Profile_Editors_Split_Hint_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternates upper and lower body.`)
};

const pt_br2_profile_editors_split_hint_upper_lower = /** @type {(inputs: Profile_Editors_Split_Hint_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterna superiores e inferiores.`)
};

const es_419_profile_editors_split_hint_upper_lower = /** @type {(inputs: Profile_Editors_Split_Hint_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterna tren superior e inferior.`)
};

const pt_pt2_profile_editors_split_hint_upper_lower = /** @type {(inputs: Profile_Editors_Split_Hint_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterna superiores e inferiores.`)
};

const fr_fr2_profile_editors_split_hint_upper_lower = /** @type {(inputs: Profile_Editors_Split_Hint_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterne haut et bas du corps.`)
};

const de_de2_profile_editors_split_hint_upper_lower = /** @type {(inputs: Profile_Editors_Split_Hint_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechselt zwischen Ober- und Unterkörper.`)
};

const it_it2_profile_editors_split_hint_upper_lower = /** @type {(inputs: Profile_Editors_Split_Hint_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterna parte superiore e inferiore.`)
};

/**
* | output |
* | --- |
* | "Alternates upper and lower body." |
*
* @param {Profile_Editors_Split_Hint_Upper_LowerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_hint_upper_lower = /** @type {((inputs?: Profile_Editors_Split_Hint_Upper_LowerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Hint_Upper_LowerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_hint_upper_lower(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_hint_upper_lower(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_hint_upper_lower(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_hint_upper_lower(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_hint_upper_lower(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_hint_upper_lower(inputs)
	return en_us2_profile_editors_split_hint_upper_lower(inputs)
});
export { profile_editors_split_hint_upper_lower as "profile-editors.split_hint_upper_lower" }